module.exports = __webpack_public_path__ + "static/img/jinbi-dark.1f244f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/jinbi-dark.png
// module id = M5sX
// module chunks = 9